export { default as MainDesktop } from './MainDesktop.vue';
export { default as Login } from './Login.vue';
export { default as Signup } from './Signup.vue';
export { default as MainPage } from './MainPage.vue';
export { default as BuyForm } from './BuyForm.vue';
export { default as LandingPage } from './LandingPage.vue';
export { default as UserList } from './UserList.vue';
export { default as SubmitDone } from './SubmitDone.vue';
// export { default as MainDesktop } from './MainDesktop.vue';
